import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enCommon from "@/locales/en/common.json";
import esCommon from "@/locales/es/common.json";

const resources = {
  en: { common: enCommon },
  es: { common: esCommon },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    supportedLngs: ["en", "es"],
    interpolation: {
      escapeValue: false,
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs, ns, key) => {
          console.warn("[i18n] Missing key", { lngs, ns, key });
        }
      : undefined,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "workscope-language",
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => (lng?.toLowerCase().startsWith("es") ? "es" : "en"),
    },
  });

export default i18n;
